import {
    QUIZ_LIST_IS_LOADING,
    QUIZ_LIST_LOAD_SUCCESS,
    QUIZ_LIST_LOAD_ERROR,
    RESET_QUIZ_LIST,
} from "../actions/action_types";

export default function quizListReducer(
    state = { quizListData: [], isLoading: false, quizListError: null },
    action
) {
    switch (action.type) {
        case QUIZ_LIST_IS_LOADING:
            return {...state, isLoading: true };
        case QUIZ_LIST_LOAD_SUCCESS:
            return {...state, quizListData: action.payload, isLoading: false };
        case QUIZ_LIST_LOAD_ERROR:
            return {...state, quizListError: action.payload, isLoading: false };
        case RESET_QUIZ_LIST:
            return { quizListData: [], isLoading: false, quizListError: null }
        default:
            return state;
    }
}